import React from 'react'
import "./Enquire_now.css"
import { Button } from 'react-bootstrap'
import Enquire_from_modal from '../../common-components/common_modal/enquire_from_modal/Enquire_from_modal'

function Enquire_now() {

    const [modalShow, setModalShow] = React.useState(false);
    return (
        <>
            <section className='Enquire_now'>
                <div className="container">
                    <div className="Enquire_now_holder">
                        <div className="row">
                            <div className="col-md-7 col-7">
                                <div className="contant_text_holder">
                                    <div className='quote_img_holder'>
                                        <img src="/assets/images/home/enquire_now/quote.png" alt="quote" className='quote_img' />
                                    </div>
                                    <div className="text_holder">
                                        <h6>Talk to a specialist to learn more about cash handling equipment</h6>
                                        <Button className='enquire_btn' onClick={() => setModalShow(true)}>Enquire</Button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-5 col-5">
                                <div className='cash_machine_img_holder'>
                                    <div className="img_holder">
                                        <img src="/assets/images/home/enquire_now/cash_machine.png" alt="cash machine" className='cash_machine_img' />
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <Enquire_from_modal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    )
}

export default Enquire_now